import React from 'react';
import { Section, SectionHeading, Reveal } from './ui/Section';

const STEPS = [
  {
    no: '01',
    title: 'お申し込み',
    body: 'フォームに必要事項をご入力ください。所要時間は1分ほどです。',
    note: 'Webフォーム',
  },
  {
    no: '02',
    title: '担当者からご連絡',
    body: 'ご入力いただいたメールアドレス宛に、2営業日以内にご連絡いたします。',
    note: '2営業日以内',
  },
  {
    no: '03',
    title: 'セットアップ',
    body: 'インストールから初期設定まで、手順書と個別サポートでご案内します。',
    note: '優先サポート',
  },
  {
    no: '04',
    title: 'ご利用開始',
    body: '30日間、すべての機能を無料でご利用いただけます。期間終了後に自動で課金されることはありません。',
    note: '無料体験',
  },
];

const Flow: React.FC = () => (
  <Section id="flow" tone="muted">
    <SectionHeading
      eyebrow="Flow"
      title="ご利用開始までの流れ"
      lead="お申し込みからご利用開始まで、複雑な手続きはありません。"
    />

    <div className="relative mt-14">
      {/* PC：横につながる線 */}
      <div className="absolute left-0 right-0 top-7 hidden h-px bg-line lg:block" aria-hidden="true" />

      <ol className="grid gap-10 lg:grid-cols-4 lg:gap-6">
        {STEPS.map((s, i) => (
          <Reveal key={s.no} delay={i * 0.1}>
            <li className="relative">
              <div className="flex items-center gap-4 lg:block">
                <span className="num relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-full border-2 border-ink-900 bg-white text-lg font-bold text-ink-900">
                  {s.no}
                </span>
                <span className="rounded-pill bg-brand-50 px-3 py-1 text-xs font-bold text-brand-700 lg:mt-5 lg:inline-block">
                  {s.note}
                </span>
              </div>
              <h3 className="mt-4 text-h3 text-ink-900">{s.title}</h3>
              <p className="mt-2 text-small leading-relaxed text-body-soft">{s.body}</p>
            </li>
          </Reveal>
        ))}
      </ol>
    </div>
  </Section>
);

export default Flow;
